// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3vcPu","amount":"Amount_amount__lLuvr","tip":"Amount_tip__2Hti9","tipHeader":"Amount_tipHeader__2hwa1","tipsWrap":"Amount_tipsWrap__2_fV-"};